<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-text-field
            label="Title"
            v-model.trim="doc.title"
            type="text"
            placeholder="Project title"
            id="title"
          ></v-text-field>
          <v-text-field
            label="Title"
            v-model.trim="doc.description"
            type="text"
            placeholder="Project description"
            id="title"
          ></v-text-field>
          <v-switch v-model="doc.showResults" label="Show results"></v-switch>
        </v-col>
        <v-col cols="12">
          <v-tabs dark>
            <v-tabs-slider></v-tabs-slider>

            <v-tab :href="`#tab-1`">Users</v-tab>
            <v-tab :href="`#tab-2`">Exercises</v-tab>
            <v-tab :href="`#tab-3`">Benchmarks</v-tab>
            <v-tab :href="`#tab-4`">Planes</v-tab>
            <v-tab :href="`#tab-5`">Functionality</v-tab>

            <v-tab-item value="tab-1">
              <!-- <v-data-table group-by="company" sort-by="first" :items="users" :headers="headers" show-group-by> -->

              <v-select
                :items="filteredCompanies"
                v-model="filterCompany"
                label="Filter by company"
                outlined
                class="mt-10 mb-2"
              ></v-select>

              <v-combobox
                v-model="selectedDropdownUsers"
                :items="filteredUsers"
                :search-input.sync="search"
                hide-selected
                hint=""
                label="Add users to the project"
                item-text="first"
                item-value="id"
                multiple
                outlined
                small-chips
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        No results matching "<strong>{{ search }}</strong
                        >"
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <template v-slot:selection="{ attrs, item, parent, selected }">
                  <v-chip
                    v-if="item === Object(item)"
                    v-bind="attrs"
                    :color="`${item.color} lighten-3`"
                    :input-value="selected"
                    label
                    small
                  >
                    <span class="pr-2">
                      {{ item.email }}
                    </span>
                    <v-icon small @click="parent.selectItem(item)">
                      $delete
                    </v-icon>
                  </v-chip>
                </template>
                <template v-slot:item="{ item }">
                  {{ item.first }}, {{ item.last }}
                  <v-spacer></v-spacer>
                  <v-chip>
                    {{ item.email }}
                  </v-chip>
                </template>
              </v-combobox>

              <!-- <v-row>
                <v-col cols="6">
                  <pre>{{ selectedDropdownUsers }}</pre>
                </v-col>
                <v-col cols="6">
                  <pre>{{ doc }}</pre>
                </v-col>
              </v-row> -->
            </v-tab-item>

            <v-tab-item value="tab-2">
              <v-row>
                <v-col cols="12">
                  <ordered-select
                    v-model="exercisesOrder"
                    collection="exercisesCollection"
                    name="exercises-sort"
                  ></ordered-select>
                </v-col>
              </v-row>
            </v-tab-item>

            <v-tab-item value="tab-3">
              <v-row>
                <v-col cols="12">
                  <ordered-select
                    v-model="benchmarksOrder"
                    collection="benchmarksCollection"
                    name="benchmarks-sort"
                  ></ordered-select>
                </v-col>
              </v-row>
            </v-tab-item>

            <v-tab-item value="tab-4">
              <v-row>
                <v-col cols="12">
                  <ordered-select
                    v-model="planesOrder"
                    collection="planesCollection"
                    name="planes-sort"
                  ></ordered-select>
                </v-col>
              </v-row>
            </v-tab-item>

            <v-tab-item value="tab-5">
              <v-row>
                <v-col cols="12">
                  <ordered-select
                    v-model="functionalityOrder"
                    collection="functionalityCollection"
                    name="functionality-sort"
                  ></ordered-select>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
// @ is an alias to /src
const fb = require("@/firebaseConfig.js");

import { OrderedSelect } from "@/components/core";

export default {
  name: "AdminProjectUpload",
  data() {
    return {
      users: null,
      filterCompany: "",
      selectedDropdownUsers: [],
      exercises: null,
      benchmarks: null,
      planes: null,
      userList: null,
      exercisesOrder: [],
      benchmarksOrder: [],
      planesOrder: [],
      functionalityOrder: [],
      intervalId: null,
      search: null,
      headers: [
        {
          text: "First name",
          align: "start",
          value: "first",
          groupable: false,
        },
        { text: "Last name", align: "right", value: "last" },
        { text: "Company", align: "right", value: "company" },
        { text: "Controls", align: "right", value: "" },
      ],
    };
  },
  components: {
    OrderedSelect,
  },
  props: {
    doc: Object,
    init: Boolean,
  },
  computed: {
    // selectedUsers() {
    //   if (this.users) {
    //     return this.users.filter((item) => item.selected === true);
    //   } else {
    //     return false;
    //   }
    // },
    filteredCompanies() {
      if (this.users) {
        const uniqueArr = [...new Set(this.users.map((data) => data.company))];
        const orderedArr = uniqueArr.sort();
        return ["", ...orderedArr];
      } else {
        return [];
      }
    },
    userListIds() {
      const users = this.doc.users.map((x) => x.uid);
      return users.filter((x) => x != null);
    },
    filteredUsers() {
      if (this.users) {
        return this.filterCompany != ""
          ? this.users.filter((item) => item.company === this.filterCompany)
          : this.users;
      } else {
        return [];
      }
    },
  },
  watch: {
    selectedDropdownUsers: {
      deep: true,
      immediate: true,
      handler(val) {
        this.$set(this.doc, "users", val);
      },
    },
    userListIds: {
      deep: true,
      immediate: true,
      handler(val) {
        this.$set(this.doc, "userListIds", val);
      },
    },
    init(val) {
      if (val) {
        this.check();
        this.loadUsers();
      }
    },
    exercisesOrder(val) {
      this.doc.exercisesOrder = val;
    },
    benchmarksOrder(val) {
      this.doc.benchmarksOrder = val;
    },
    planesOrder(val) {
      this.doc.planesOrder = val;
    },
    functionalityOrder(val) {
      this.doc.functionalityOrder = val;
    },
    doc: {
      deep: true,
      immediate: true,
      handler(val) {
        this.selectedDropdownUsers = val.users;
      },
    },
  },
  mounted() {
    this.check();
    this.loadUsers();
  },
  methods: {
    check() {
      let vm = this;
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.intervalId = setInterval(function() {
        vm.checkStatus();
      }, 300);
    },
    checkStatus() {
      if (this.doc && this.users) {
        clearInterval(this.intervalId);
        if (this.doc.exercisesOrder) {
          this.exercisesOrder = this.doc.exercisesOrder;
        }
        if (this.doc.benchmarksOrder) {
          this.benchmarksOrder = this.doc.benchmarksOrder;
        }
        if (this.doc.planesOrder) {
          this.planesOrder = this.doc.planesOrder;
        }
        if (this.doc.functionalityOrder) {
          this.functionalityOrder = this.doc.functionalityOrder;
        }
      }
    },
    loadUsers() {
      console.log("load users");
      fb.profilesCollection
        .get()
        .then((docs) => {
          let items = [];
          docs.forEach((docs) => {
            let doc = docs.data();
            items.push(doc);
          });
          this.users = items;
        })
        .catch(() => {});
      console.log("doc", this.doc);
    },
    checkId(arr, id) {
      let filteredList = arr.filter((item) => item.id == id);
      return filteredList.length >= 1 ? true : false;
    },
    selectItem(arr, id) {
      let vm = this;
      let item = arr.find((item) => item.id === id);
      let indexOfItem = arr.indexOf(item);
      vm.$set(arr, indexOfItem, item);
    },
  },
};
</script>
